

  
const content = `# SecureAI Installation and Configuration
  
The OnData SecureAI product can be deployed to a customer's own network environment, either on-premises or in the cloud, so that it can access existing data sources for data 
insights and/or workflow automation. The SecureAI product can work with a variety of database engines, such as Microsoft SQL Server, Oracle, PostgreSQL, and MySQL. The purpose 
of this guide is to detail the procedure to install and configure the OnData SecureAI product.
    
The OnData SecureAI product supports two deployment models: 1) deploy as Docker containers; or 2) deploy to web servers. The Docker container model is very portable and can be 
easily deployed with all dependencies included inside the Docker container images. The web server model requires more manual installation and configuration. Please refer to 
sections below on how to install and configure the OnData SecureAI product with different deployment models.

* [**Deploy SecureAI with Docker**](reference_doc#secureai/installation_and_configuration/deploy_with_docker)
* **Deploy SecureAI with Microsoft IIS Server**
* **Deploy SecureAI with NGINX on Linux**
  
After the SecureAI App and associated data sources are deployed, you can follow the instructions to [**Configure SecureAI App**](reference_doc#secureai/installation_and_configuration/configure_secureai_app)
  
  `
  
export default content;
